jQuery(function ($) {
  $(document).on("click", ".search-accordion-item__button", function (e) {
    e.preventDefault();
    $(this).parents(".search-accordion-item").toggleClass("active");
  });
});
